import { render, staticRenderFns } from "./ExtraSearch.vue?vue&type=template&id=e28d37f6&"
import script from "./ExtraSearch.vue?vue&type=script&lang=js&"
export * from "./ExtraSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports